//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import ReactExport from "react-data-export";
import * as moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function StatementXLSX({ states, startDate, endDate, page }) {
    const { excelData } = states;
    let transactions = excelData?.transactionHistory?.map((t) => [
        {
            value: t?.transaction_date,
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.shipto + String.fromCharCode(8203),
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.order_number + String.fromCharCode(8203),
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.transaction_type,
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.offer_description,
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.offer_rate + String.fromCharCode(8203),
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.tier,
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.base_rate + String.fromCharCode(8203),
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: parseInt(t?.dollar_amount) >= 0 ?
                `$${t?.dollar_amount}` : parseInt(t?.dollar_amount) < 0 ? `-$${t?.dollar_amount.replace('-', '')}` : '-',
            style: { alignment: { horizontal: "right" } },
        },
        {
            value: t?.points,
            style: { alignment: { horizontal: "right" } },
        },
    ]);

    let headerEnrollStyles = {
        font: { bold: true, color: { rgb: "FFFFFFFF" } },
        fill: { patternType: "solid", fgColor: { rgb: "00315496" } },
    };

    let borderStyles = {
        border: {
            top: { style: "thin", color: { rgb: "00000000" } },
            bottom: { style: "thin", color: { rgb: "00000000" } },
            left: { style: "thin", color: { rgb: "00000000" } },
            right: { style: "thin", color: { rgb: "00000000" } },
        },
    };

    let descriptonBorderStyles = {
        border: {
            left: { style: "thin", color: { rgb: "00FFFFFF" } },
            right: { style: "thin", color: { rgb: "00FFFFFF" } },
        },
    };

    let header1Styles = {
        style: {
            font: { bold: true },
            alignment: { horizontal: "center" },
            ...borderStyles,
        },
    };

    const multiDataSet = [        
        {
            columns: [
                { title: "", width: { wch: 250 } },
            ],
            data: [
                [
                    { value: "For a full description of points earned, redemptions, and information related to discounts received, please review your dashboard at HenryScheinDental.com/ThriveRewards", style: { ...descriptonBorderStyles } },
                ],
            ]
        },
        {
            columns: [
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 19 } },
                { title: "", width: { wch: 21 } },
                { title: "", width: { wch: 23 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
                { title: "", width: { wch: 20 } },
            ],
            data: [
                [
                    { value: "", style: { ...headerEnrollStyles } },
                    { value: "", style: { ...headerEnrollStyles } },
                    { value: "", style: { ...headerEnrollStyles } },
                    { value: "", style: { ...headerEnrollStyles } },
                    {
                        value: `Report Period: ${startDate}`,
                        style: { ...headerEnrollStyles },
                    },
                    {
                        value: `to ${endDate}`,
                        style: { ...headerEnrollStyles }
                    },
                    { value: "", style: { ...headerEnrollStyles } },
                    { value: "", style: { ...headerEnrollStyles } },
                ],
                [
                    {
                        value: "Report Date",
                        ...header1Styles,
                    },
                    {
                        value: "Loyalty ID",
                        ...header1Styles,
                    },
                    {
                        value: "Starting Balance",
                        ...header1Styles,
                    },
                    {
                        value: "Points Earned",
                        ...header1Styles,
                    },
                    {
                        value: "Points Adjusted",
                        ...header1Styles,
                    },
                    {
                        value: "Points Redeemed",
                        ...header1Styles,
                    },
                    {
                        value: "Points Expired",
                        ...header1Styles,
                    },
                    {
                        value: "Ending Balance",
                        ...header1Styles,
                    },
                ],
                [
                    {
                        value: moment().format("MM/DD/YYYY"),
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.loyaltyId + String.fromCharCode(8203),
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.currentBalance,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.pointsEarned,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.pointsAdjusted,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.pointsRedeemed,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.pointsExpired,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                    {
                        value: excelData?.endingBalance,
                        style: {
                            ...borderStyles,
                            alignment: { horizontal: "center" },
                        },
                    },
                ],
                // Empty Row
                [
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                    { value: "", style: { ...descriptonBorderStyles } },
                ],
                // Headings
                [
                    {
                        value: "Post Date",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Ship to Account",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Order Number",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Transaction Type",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Offer Description",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Offer Rate",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Tier",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Base Rate",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Purchase Amount",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                    {
                        value: "Points Earned",
                        style: {
                            ...headerEnrollStyles,
                            alignment: { horizontal: "center" },
                            ...borderStyles,
                        },
                    },
                ],
                ...(transactions || []),
            ],
        },
    ];

    return (
        <ExcelFile
            filename={
                `${page.replace(/ /g, "")}` +
                " " +
                moment(new Date()).format("MM-DD-YYYY,h:mm A")
            }
            element={
                <button id="csv" style={{ display: "none" }}>
                    Hidden btn
                </button>
            }
        >
            <ExcelSheet dataSet={multiDataSet} name="Organization" />
        </ExcelFile>
    );
}
